import request from '@/utils/request';

const PATH = '/reservation/schedule/part';

export const getSchedulePart = (itemUid: string) => request({
  url: `${PATH}/${itemUid}`,
  method: 'get',
});

export const getSchedulePartList = (itemUid: string) => request({
  url: `${PATH}/${itemUid}/list`,
  method: 'get',
});

export const isUpdatePossiable = (params: any) => request({
  url: `${PATH}/updatepossiable`,
  method: 'get',
  params,
});
